import React, {useEffect, useState} from "react";
import {firestore} from "../firebase/clientApp";
import {Avatar, Box, Button, ButtonGroup, Container, Grid, Typography} from "@mui/material";

import axios from "axios";
import {useParams} from "react-router-dom";
import {useDocument} from "react-firebase-hooks/firestore";

import clap from '../assets/images/clap.png'
import fist from '../assets/images/fist.png'
import {emojisplosion} from "emojisplosion";
import {API_URL} from "../config";

const emojis = ['☢️','🆘' , '‼️' ,'💦','⚠️' , '🔥' ,'🔥','🔥','🔥','🔥','🔥','🔥','🔥' ,'👾' , ]

export default function Applausometro({url, idPlaying, eventPlaying, user}) {
    const {id} = useParams()

    async function postDataApplausi(e) {
        emojisplosion({
            emojiCount:10,
            physics: {gravity: 0.05},
            emojis: [emojis[Math.floor(Math.random()*emojis.length)]],
            position: () => ({
                x: e.clientX,
                y: e.clientY,
            }),
        })
        await axios.post(`${API_URL}/${id}/applausi`, {user: user.uid})
            .then(r => {
                navigator.vibrate(200)
            })
            .catch(error => console.log(error))
    }

    const ButtonItem = () => (
        <Button id='clapButton' disabled={!eventPlaying} onClick={postDataApplausi} fullWidth
                variant={"clap"}
            startIcon={<img style={{height:'12.625rem'}} src={fist} />}
        >
        </Button>
    )

    return (
        <Box sx={{position:'absolute', bottom:'0', my:2, width:'min(35rem, calc(100% - 32px))'}}>
            <ButtonItem/>
        </Box>
    )
}
